import { useState } from 'react'
import { useParams } from 'react-router-dom'

import { TrainingFormWithTrainingDocument } from 'generated/resources/graphql'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useQuery } from 'modules/core/hooks/useQuery'

import { ResponsivePage } from 'modules/layout/components/ResponsivePage'
import { Form } from 'modules/trainings/components/Revamp/Form'
import { useTrainingSurveyActions } from 'modules/trainings/hooks/useTrainingSurveyActions'

const TrainingFormDetail = () => {
  const { id, formId } = useParams<{ id: string; formId: string }>()
  const { company } = useCurrentSession()
  const { data, loading, error } = useQuery(TrainingFormWithTrainingDocument, {
    variables: { id: formId ?? '', trainingId: Number(id), companyId: company.id },
  })

  const trainingForm = data?.forms.form ?? undefined
  const [openSidepanel, setOpenSidepanel] = useState<boolean>(false)

  const { handleActionClick } = useTrainingSurveyActions()

  return (
    <ResponsivePage.Body
      loading={loading}
      error={error}
      variant="fullscreen"
      onActionClick={handleActionClick}
    >
      <Form
        openSidepanel={openSidepanel}
        setOpenSidepanel={setOpenSidepanel}
        trainingForm={trainingForm}
        trainingId={Number(id)}
      />
    </ResponsivePage.Body>
  )
}

export default TrainingFormDetail
